import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import Button from "../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import { IndentSelect } from "../../../Reusable/IndentSelect";
import IndentStatusView from "../../../purchaseFormPages/IndentStatusView";
import { PartySelect } from "../../../Reusable/PartySelect";
import { Link, useNavigate } from "react-router-dom";
import { QuotationIndentSelect } from "./QuotationIndentSelect";
import { QuotationPartySelect } from "./QuotationPartySelect";
import QuotationPageForm from "./QuotationPageForm";

export default function UpdateQuotation() {
  const {
    darkTheme,
    loginData,
    setIndentCreateItemId4Upd,
    quotationIndentId,
    quotationPartyId,
    setQuotationIndentId,
    setQuotationPartyId,
  } = useContext(UserContext);

  const [indent, setIndent] = useState("");
  const [party, setParty] = useState("");
  const [negoAmountTotal, setNegoAmountTotal] = useState(0);
  const [updQuotation, setUpdQuotation] = useState({});
  const [getQuotationItem, setGetQuotationItem] = useState([
    // {
    //   quotation_item_id: null,
    //   indent_item_id: 19,
    //   division: "Kpk division 1",
    //   hsn_gst_percent: "12.00",
    //   hsn_no: "1120",
    //   item_code: "#KPK 1",
    //   item_name: "Kamleshwar 1",
    //   brand_name: null,
    //   unit: "Kpk UNIt 1",
    //   qty: "65",
    //   quoted_unit_rate: null,
    //   quoted_amount: null,
    //   discount: null,
    //   final_amount: null,
    //   negotiation_rate: null,
    //   negotiation_amount: null,
    // },
    // {
    //   quotation_item_id: null,
    //   indent_item_id: 27,
    //   division: "Kpk division 1",
    //   hsn_gst_percent: "12.00",
    //   hsn_no: "1120",
    //   item_code: "#KPK 1",
    //   item_name: "Kamleshwar 1",
    //   brand_name: null,
    //   unit: "Kpk UNIt 1",
    //   qty: "12",
    //   quoted_unit_rate: null,
    //   quoted_amount: null,
    //   discount: null,
    //   final_amount: null,
    //   negotiation_rate: null,
    //   negotiation_amount: null,
    // },
    // {
    //   quotation_item_id: null,
    //   indent_item_id: 27,
    //   division: "Kpk division 1",
    //   hsn_gst_percent: "12.00",
    //   hsn_no: "1120",
    //   item_code: "#KPK 1",
    //   item_name: "Kamleshwar 1",
    //   brand_name: null,
    //   unit: "Kpk UNIt 1",
    //   qty: "12",
    //   quoted_unit_rate: null,
    //   quoted_amount: null,
    //   discount: null,
    //   final_amount: null,
    //   negotiation_rate: null,
    //   negotiation_amount: null,
    // },
  ]);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getQuotation(quotationPartyId, quotationIndentId);
  }, []);

  const getQuotation = async (partyId, indentId) => {
    setSpinner(true);
    const response = await fetch(
      `${BaseURL}/purchase/quotation/getquotation?indent_id=${indentId}&party_id=${partyId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status) {
      setSpinner(false);
      setGetQuotationItem(data.data.quotation_items);
      setUpdQuotation(data.data);
      calcNegotiationAmountTotal(getQuotationItem);
    }
    if (data.status === false) {
      toast.error("Go to View Quotation page for update button");
    }
  };

  function calcNegotiationAmountTotal(data) {
    let negotiationTotal = 0;
    data.forEach((item, index) => {
      negotiationTotal += parseFloat(item.negotiation_amount);
    });
    setNegoAmountTotal(negotiationTotal);
  }
  useEffect(() => {
    calcNegotiationAmountTotal(getQuotationItem);
  }, [getQuotationItem]);

  // create
  async function submitQuotationItems(e) {
    e.preventDefault();

    setSubmitDisable(true);
    const formData = {
      indent_id: updQuotation?.indent?.id,
      party_id: updQuotation?.party?.id,
      quotations: getQuotationItem,
      quotation_sum_amount: negoAmountTotal,
    };
    console.log({ quotations: formData });

    const res = await fetch(`${BaseURL}/purchase/quotation/save`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          setQuotationIndentId(0);
          setQuotationPartyId(0);
          navigate("/purchase/view-quotation");
          // getUnsavedItemList();
          toast.success("Success");
          setGetQuotationItem([]);
          setParty("");
          setIndent("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          toast.error("Submition error");
          setSubmitDisable(false);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    fetch(`${BaseURL}/purchase/indent/getcacheitem/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          setChangingSelect(true);
          setSubmitAction("update");

          // setDivision(selectedRecord.data.division || "");
        }
      });
    setChangingSelect(false);
  }

  function cancelUpdate() {
    navigate("/purchase/view-quotation");
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setGetQuotationItem([]);
    setParty("");
    setIndent("");
    setQuotationIndentId(0);
    setQuotationPartyId(0);
  }
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Update Quotation
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-3 md:gap-1 lg:gap-4"
          >
            <div className="px-2 mb-6 flex w-full flex-wrap">
              <form>
                <div className="flex flex-wrap gap-x-2 gap-y-2">
                  <div className="mb-2 min-w-[260px] max-w-[460px]">
                    <label>Indent Doc. No.</label>
                    <input
                      type="text"
                      disabled={true}
                      className={`border block uppercase rounded-lg py-[8px] px-3 outline-none border-gray-300 text-gray-400 font-bold bg-[#ffff]`}
                      value={updQuotation?.indent?.code || ""}
                    />
                    {/* <QuotationIndentSelect
                      selectedOption={indent}
                      setSelectedOption={setIndent}
                      changingSelect={changingSelect}
                      cancelUpdate={cancelUpdate}
                      setGetQuotationItem={setGetQuotationItem}
                      getQuotationItem={getQuotationItem}
                      setParty={setParty}
                      party={party}
                    /> */}
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <div className="min-w-[260px] max-w-[460px]">
                      <label>Party Name</label>
                      <input
                        type="text"
                        disabled={true}
                        className={`border block uppercase rounded-lg py-[8px] px-3 outline-none border-gray-300 text-gray-400 font-bold bg-[#ffff]`}
                        value={updQuotation?.party?.name || ""}
                      />
                      {/* <QuotationPartySelect
                        selectedOption={party}
                        setSelectedOption={setParty}
                        changingSelect={changingSelect}
                        indentId={indent && indent.value}
                      /> */}
                    </div>
                  </div>
                </div>
              </form>
              <div>
                <button
                  onClick={() =>
                    getQuotation(quotationPartyId, quotationIndentId)
                  }
                  className="bg-green-600 rounded-md px-4 py-2 text-white mt-5 ml-3"
                >
                  Reload
                </button>
              </div>
            </div>

            <div className="w-full px-2">
              <QuotationPageForm
                editBtn={editBtn}
                // firstPageList={firstPageList}
                links={links}
                firstPage={getQuotationItem}
                setFirstPage={setGetQuotationItem}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
                negoAmountTotal={negoAmountTotal}
                setNegoAmountTotal={setNegoAmountTotal}
                calcNegotiationAmountTotal={calcNegotiationAmountTotal}
              />
            </div>

            {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1 mt-2">
                <Button
                  disabled={submitDisable}
                  type="submit"
                  onClick={(e) => submitQuotationItems(e)}
                >
                  {submitDisable ? "Wait.." : "Update"}
                </Button>
                <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
